import React from 'react';
import {
  ListItem,
  ListItemText,
  Avatar,
  List,
  ListItemIcon,
  ListItemSecondaryAction,
  IconButton,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { ReactComponent as Edit } from 'Images/icons/ic_details_edit.svg';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  profileAvatar: {
    borderRadius: 12,
    fontSize: '14px',
    color: '#fff',
    background: 'linear-gradient(315deg, #00cdcd, #009e9f)',
  },
  noPadding: {
    padding: 0,
  },
}));

export default function UserProfile(props) {
  const classes = useStyles();
  const { name, designation, handleEdit, enableEdit } = props;
  var nameIcon = '';
  if (name) {
    var nameSplit = name.split(' ');
    for (var i = 0; i < nameSplit.length; i++) {
      nameIcon += nameSplit[i].charAt(0);
      if (i === 1) {
        break;
      }
    }
  }

  return (
    <List>
      <ListItem className={classes.noPadding}>
        <ListItemIcon>
          <Avatar className={classes.profileAvatar}>{nameIcon}</Avatar>
        </ListItemIcon>
        <ListItemText primary={name} secondary={designation} />
        {enableEdit ? (
          <ListItemSecondaryAction>
            <IconButton className={classes.noPadding} onClick={handleEdit}>
              <Edit />
            </IconButton>
          </ListItemSecondaryAction>
        ) : null}
      </ListItem>
    </List>
  );
}

UserProfile.propTypes = {
  name: PropTypes.string.isRequired,
  designation: PropTypes.string.isRequired,
  enableEdit: PropTypes.bool.isRequired,
  handleEdit: PropTypes.func,
};
